import {ABI, BASE_IMGIX_URL, CONTRACT_ADDRESS, WS_HOST} from "../variables"
import Web3 from "web3"

export const web3 = new Web3(WS_HOST)
export const cg = new web3.eth.Contract(ABI as any, CONTRACT_ADDRESS)

export const imgixCryptogramFilename = (item: string | number) => `${BASE_IMGIX_URL}/${item}.png`
export const imgixAssetFilename = (name: string) => `${BASE_IMGIX_URL}/assets/${name}`